import ReactDOM from 'react-dom';
import '@openfonts/poppins_latin-ext';
import './i18n';
import './react-chartjs-2-defaults';
import './styles/app-base.css';
import './styles/app-components.css';
import './styles/app-utilities.css';
import 'react-advanced-cropper/dist/style.css';
import App from 'app/App';
import reportWebVitals from './reportWebVitals';

ReactDOM.render(<App />, document.getElementById('root'));

reportWebVitals();